// Styles CSS de l'éditeur 
export const CUSTOM_STYLES = `
  /* Force l'application des styles Quill */
  .ql-editor {
    font-family: 'Segoe UI', 'Calibri', 'Helvetica Neue', Arial, sans-serif !important;
    font-size: 12pt !important;
    line-height: 1.6 !important;
    padding: 32px 40px !important;
    min-height: 400px !important;
  }

  /* Styles des titres - IMPORTANT: Forcer l'application */
  .ql-editor h1, 
  .ql-editor .ql-size-huge {
    font-size: 2.5em !important;
    color: #1e293b !important;
    margin: 1.2em 0 0.6em 0 !important;
    font-weight: 700 !important;
    line-height: 1.2 !important;
    border-bottom: 3px solid #57a863 !important;
    padding-bottom: 0.3em !important;
  }

  .ql-editor h2,
  .ql-editor .ql-size-large {
    font-size: 2em !important;
    color: #1e293b !important;
    margin: 1em 0 0.5em 0 !important;
    font-weight: 600 !important;
    line-height: 1.3 !important;
    border-bottom: 2px solid #57a863 !important;
    padding-bottom: 0.2em !important;
  }

  .ql-editor h3 {
    font-size: 1.5em !important;
    color: #1e293b !important;
    margin: 0.8em 0 0.4em 0 !important;
    font-weight: 600 !important;
    line-height: 1.4 !important;
    border-bottom: 1px solid #57a863 !important;
    padding-bottom: 0.1em !important;
  }

  .ql-editor h4 {
    font-size: 1.25em !important;
    color: #1e293b !important;
    margin: 0.7em 0 0.35em 0 !important;
    font-weight: 600 !important;
    line-height: 1.4 !important;
  }

  .ql-editor h5 {
    font-size: 1.1em !important;
    color: #1e293b !important;
    margin: 0.6em 0 0.3em 0 !important;
    font-weight: 600 !important;
    line-height: 1.4 !important;
  }

  .ql-editor h6 {
    font-size: 1em !important;
    color: #1e293b !important;
    margin: 0.5em 0 0.25em 0 !important;
    font-weight: 600 !important;
    line-height: 1.4 !important;
  }

  /* Styles des polices - Forcer l'application */
  .ql-font-arial { font-family: Arial, sans-serif !important; }
  .ql-font-comic-sans { font-family: 'Comic Sans MS', cursive !important; }
  .ql-font-courier-new { font-family: 'Courier New', monospace !important; }
  .ql-font-georgia { font-family: Georgia, serif !important; }
  .ql-font-helvetica { font-family: Helvetica, sans-serif !important; }
  .ql-font-lucida { font-family: 'Lucida Sans Unicode', sans-serif !important; }

  /* Styles des tailles - Forcer l'application */
  .ql-size-small { font-size: 0.8em !important; }
  .ql-size-large { font-size: 1.2em !important; }
  .ql-size-huge { font-size: 1.5em !important; }

  /* Styles des listes - Correction des puces */
  .ql-editor ul {
    list-style-type: disc !important;
    padding-left: 1.5em !important;
    margin: 1em 0 !important;
  }

  .ql-editor ol {
    list-style-type: decimal !important;
    padding-left: 1.5em !important;
    margin: 1em 0 !important;
  }

  .ql-editor li {
    margin: 0.5em 0 !important;
    padding-left: 0.3em !important;
    line-height: 1.6 !important;
  }

  .ql-editor ul li {
    list-style-type: disc !important;
  }

  .ql-editor ol li {
    list-style-type: decimal !important;
  }

  /* Styles d'indentation */
  .ql-indent-1 { padding-left: 3em !important; }
  .ql-indent-2 { padding-left: 6em !important; }
  .ql-indent-3 { padding-left: 9em !important; }
  .ql-indent-4 { padding-left: 12em !important; }
  .ql-indent-5 { padding-left: 15em !important; }
  .ql-indent-6 { padding-left: 18em !important; }
  .ql-indent-7 { padding-left: 21em !important; }
  .ql-indent-8 { padding-left: 24em !important; }

  /* Styles d'alignement */
  .ql-align-center { text-align: center !important; }
  .ql-align-right { text-align: right !important; }
  .ql-align-justify { text-align: justify !important; }

  /* Style spécial pour les légendes de figures */
  .ql-editor .figure-caption {
    font-size: 0.9em !important;
    font-style: italic !important;
    color: #6b7280 !important;
    text-align: center !important;
    margin: 0.5em 0 1.5em 0 !important;
    padding: 0.5em !important;
    border-bottom: 1px solid #e5e7eb !important;
  }

  /* Style pour les notes de bas de page */
  .ql-editor .footnote {
    font-size: 0.8em !important;
    color: #6b7280 !important;
    border-top: 1px solid #e5e7eb !important;
    margin-top: 2em !important;
    padding-top: 1em !important;
  }

  .ql-editor .footnote-ref {
    vertical-align: super !important;
    font-size: 0.7em !important;
    color: #57a863 !important;
    cursor: pointer !important;
  }

  /* Styles de contenu général */
  .ql-editor p {
    margin-bottom: 1.2em !important;
    color: #374151 !important;
  }

  .ql-editor blockquote {
    border-left: 4px solid #57a863 !important;
    margin: 1.5em 0 !important;
    padding: 1em 1.5em !important;
    background: rgba(87, 168, 99, 0.03) !important;
    border-radius: 0 8px 8px 0 !important;
    font-style: italic !important;
  }

  .ql-editor pre {
    background: #f8fafc !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 8px !important;
    padding: 1.5em !important;
    margin: 1.5em 0 !important;
    font-family: 'JetBrains Mono', 'Fira Code', 'Consolas', monospace !important;
    font-size: 0.9em !important;
    overflow-x: auto !important;
  }

  .ql-editor img {
    max-width: 100% !important;
    height: auto !important;
    margin: 1.5em auto !important;
    display: block !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  }

  /* Styles de la barre d'outils */
  .ql-toolbar.ql-snow {
    border-radius: 8px 8px 0 0 !important;
    background: white !important;
    border-bottom: 1px solid #e2e8f0 !important;
    padding: 12px 16px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
  }

  .ql-toolbar .ql-picker-label {
    border: 1px solid #e2e8f0 !important;
    border-radius: 4px !important;
    padding: 4px 8px !important;
    transition: all 0.2s ease !important;
  }

  .ql-toolbar .ql-picker-label:hover {
    border-color: #57a863 !important;
    background: rgba(87, 168, 99, 0.05) !important;
  }

  .ql-toolbar button {
    width: 32px !important;
    height: 32px !important;
    border-radius: 4px !important;
    transition: all 0.2s ease !important;
  }

  .ql-toolbar button:hover {
    background: rgba(87, 168, 99, 0.1) !important;
    color: #57a863 !important;
  }

  .ql-toolbar button.ql-active {
    background: #57a863 !important;
    color: white !important;
  }

  /* Layout général */
  .editor-layout {
    display: flex;
    height: calc(100vh - 200px);
    min-height: 600px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    background: white;
  }

  /* Navigation Panel */
  .navigation-panel {
    width: 280px;
    background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);
    border-right: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
  }

  .navigation-panel.collapsed {
    width: 60px;
  }

  .nav-header {
    padding: 16px 20px;
    border-bottom: 1px solid #e2e8f0;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .nav-title {
    font-weight: 600;
    color: #1e293b;
    font-size: 14px;
  }

  .nav-toggle {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    color: #64748b;
    transition: all 0.2s ease;
  }

  .nav-toggle:hover {
    background: #f1f5f9;
    color: #1e293b;
  }

  .nav-content {
    flex: 1;
    overflow-y: auto;
    padding: 16px 0;
  }

  .nav-section {
    margin-bottom: 24px;
  }

  .nav-section-title {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 0 20px 8px;
    margin-bottom: 8px;
  }

  .nav-item {
    display: flex;
    align-items: center;
    padding: 8px 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #475569;
    font-size: 13px;
    border-left: 3px solid transparent;
  }

  .nav-item:hover {
    background: rgba(87, 168, 99, 0.05);
    color: #57a863;
  }

  .nav-item.active {
    background: rgba(87, 168, 99, 0.1);
    color: #57a863;
    border-left-color: #57a863;
    font-weight: 500;
  }

  .nav-item-icon {
    width: 16px;
    height: 16px;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .outline-item {
    padding-left: calc(20px + 16px * var(--level, 0));
    position: relative;
  }

  .outline-item::before {
    content: '';
    position: absolute;
    left: calc(12px + 16px * var(--level, 0));
    top: 50%;
    width: 4px;
    height: 4px;
    background: #94a3b8;
    border-radius: 50%;
    transform: translateY(-50%);
  }

  /* Zone d'édition */
  .editor-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: white;
  }

  /* Onglets de langues */
  .language-tabs {
    display: flex;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
  }

  .language-tab {
    padding: 12px 24px;
    background: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 13px;
    font-weight: 500;
    color: #64748b;
    position: relative;
  }

  .language-tab:hover {
    background: rgba(87, 168, 99, 0.05);
    color: #57a863;
  }

  .language-tab.active {
    background: white;
    color: #57a863;
    border-bottom: 2px solid #57a863;
  }

  /* Presets de styles améliorés */
  .editor-toolbar {
    background: white;
    border-bottom: 1px solid #e2e8f0;
    padding: 12px 16px;
  }

  .toolbar-section {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  .toolbar-section:last-child {
    margin-bottom: 0;
  }

  .style-presets {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .style-preset {
    min-width: 100px;
    text-align: center;
    padding: 10px 16px;
    cursor: pointer;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    position: relative;
    background: white;
    transition: all 0.2s ease;
  }

  .style-preset:hover {
    border-color: #57a863;
    box-shadow: 0 2px 8px rgba(87, 168, 99, 0.1);
    transform: translateY(-1px);
  }

  .style-preset-selected {
    border-color: #57a863;
    background: rgba(87, 168, 99, 0.05);
    box-shadow: 0 2px 12px rgba(87, 168, 99, 0.15);
  }

  .style-preset-preview {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
    color: #1e293b;
  }

  .style-preset-name {
    font-size: 11px;
    color: #64748b;
  }

  /* Barre de statut */
  .status-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8fafc;
    padding: 8px 20px;
    border-top: 1px solid #e2e8f0;
    font-size: 12px;
    color: #64748b;
  }

  .status-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .status-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #10b981;
  }

  /* Mode aperçu */
  .preview-mode {
    background: #f1f5f9;
    padding: 24px;
    overflow-y: auto;
    height: 100%;
  }

  .preview-page {
    background: white;
    max-width: 800px;
    margin: 0 auto;
    padding: 60px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    min-height: 1000px;
  }

  /* Boutons d'action */
  .action-buttons {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .btn-primary {
    background: linear-gradient(135deg, #57a863 0%, #4ade80 100%);
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .btn-primary:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(87, 168, 99, 0.3);
  }

  .btn-secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .btn-secondary:hover {
    border-color: #57a863;
    color: #57a863;
    transform: translateY(-1px);
  }

  /* Responsive */
  @media (max-width: 768px) {
    .editor-layout {
      flex-direction: column;
      height: auto;
    }
    
    .navigation-panel {
      width: 100%;
      height: auto;
      max-height: 200px;
    }
    
    .navigation-panel.collapsed {
      height: 60px;
      overflow: hidden;
    }
    
    .ql-editor {
      padding: 20px !important;
    }
    
    .preview-page {
      padding: 30px 20px;
    }
  }

  /* Scrollbars */
  .nav-content::-webkit-scrollbar,
  .preview-mode::-webkit-scrollbar {
    width: 6px;
  }

  .nav-content::-webkit-scrollbar-track,
  .preview-mode::-webkit-scrollbar-track {
    background: #f1f5f9;
  }

  .nav-content::-webkit-scrollbar-thumb,
  .preview-mode::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }

  .nav-content::-webkit-scrollbar-thumb:hover,
  .preview-mode::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;